import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { parseUrlParams } from 'utils/parseUrlParams';

import {
  newCheckInAction,
  NEW_CHECKIN,
} from '../../actions/navigation';

import Header from '../../components/Header';
import Transition from '../../components/Transition';
import Progress from '../../components/Progress';

// Configuration & Assets
import { useConfig } from '../../config/ConfigContext';

const isProgressVisible = true;
const VerificationCheckin = (props) => {
  const config = useConfig();
  const [uploadingPercentage, setUploadingPercentage] = useState(true);

  useEffect(() => {
    const { dispatch } = props;

    const params = parseUrlParams(window.location.search);
    dispatch(newCheckInAction({
      key: params.key,
      workflowType: 'verification',
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
    }));
  }, []);

  useEffect(() => {
    const { fetch, navigate, checkinData } = props;

    if (fetch.isDone[`${NEW_CHECKIN}`] && !fetch.isRunning[`${NEW_CHECKIN}`]) {
      // extract route url from the api response
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(`${routeUrl}`);
    }
  }, [props.checkinData]);

  return (
    <Transition className="transition-item wrapper v-center">
      <Header />
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </Transition>
  );
};

VerificationCheckin.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(VerificationCheckin);
